import { type FC } from "react";
import { type ActionProps } from "@legacy_user_frontend/components/pages/jobs/job_search_navigation/src/search_modal/src/search_modal_props";
import { Lists } from "./ui_parts/lists";
import * as styles from "./src/styles.css";

export type BusinessTypeModalProps = {
  businessTypeContents: {
    name: string;
    occupations: {
      value: string;
      url: string;
      name: string;
      showLink: boolean;
    }[];
  }[];
  dispatchFormState: React.Dispatch<ActionProps>;
  formState: Record<string, { url: string }>;
};

export const BusinessTypeModal: FC<BusinessTypeModalProps> = ({
  businessTypeContents,
  dispatchFormState,
  formState,
}) => {
  const handleOnBusinessTypeStateChange = (e: React.ChangeEvent<HTMLInputElement>, url: string) => {
    if (e.currentTarget.checked) {
      dispatchFormState({
        type: "selectBusinessType",
        value: e.target.value,
        url,
      });
    } else {
      dispatchFormState({ type: "unSelectBusinessType", value: e.target.value });
    }
  };
  return (
    <>
      {businessTypeContents.map(({ name, occupations }) => (
        <div className={styles.outer} key={name}>
          <dd className={styles.parentOuter}>
            <p className={styles.parentText}>{name}</p>
          </dd>
          <dd>
            <ul className={styles.childLists}>
              <Lists
                contents={occupations}
                formState={formState}
                changeEvent={handleOnBusinessTypeStateChange}
                checkBoxName="q[business_type][]"
                type="checkbox"
              />
            </ul>
          </dd>
        </div>
      ))}
    </>
  );
};
